"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _page = _interopRequireDefault(require("./yl/components/page"));
var _ylArrayObject = _interopRequireDefault(require("./yl/components/ylArrayObject"));
var _ylButton = _interopRequireDefault(require("./yl/components/ylButton"));
var _ylCard = _interopRequireDefault(require("./yl/components/ylCard"));
var _ylDataCensus = _interopRequireDefault(require("./yl/components/ylDataCensus"));
var _ylDialog = _interopRequireDefault(require("./yl/components/ylDialog"));
var _ylForm = _interopRequireDefault(require("./yl/components/ylForm"));
var _ylImageViewer = _interopRequireDefault(require("./yl/components/ylImageViewer"));
var _ylSearchForm = _interopRequireDefault(require("./yl/components/ylSearchForm"));
var _ylTable = _interopRequireDefault(require("./yl/components/ylTable"));
var _ylTitle = _interopRequireDefault(require("./yl/components/ylTitle"));
var _ylUpload = _interopRequireDefault(require("./yl/components/ylUpload"));
var _ylFormReadOnly = _interopRequireDefault(require("./yl/components/ylFormReadOnly"));
var _ylTree = _interopRequireDefault(require("./yl/components/ylTree"));
var _ylIcon = _interopRequireDefault(require("./yl/components/ylIcon"));
var _ylText = _interopRequireDefault(require("./yl/components/ylText"));
var _LineChart = _interopRequireDefault(require("./Charts/LineChart"));
var _PieChart = _interopRequireDefault(require("./Charts/PieChart"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var componentAll = [_page["default"], _ylArrayObject["default"], _ylButton["default"], _ylCard["default"], _ylDataCensus["default"], _ylDialog["default"], _ylForm["default"], _ylImageViewer["default"], _ylSearchForm["default"], _ylTable["default"], _ylTitle["default"], _ylUpload["default"], _ylFormReadOnly["default"], _LineChart["default"], _PieChart["default"], _ylTree["default"], _ylIcon["default"], _ylText["default"]];
var _default = {
  install: function install(Vue) {
    componentAll.map(function (child) {
      Vue.component(child.name, child);
    });
  }
};
exports["default"] = _default;